import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigService } from '../config/config.service';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class ApiBaseInterceptor implements HttpInterceptor {
  constructor(
    private readonly config: ConfigService,
    private readonly auth: AuthService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith('http')) {
      // Stare serwisy (services/*.service.ts i czesc features/) wolaja office
      // absolutnym URL-em. Od 17.09.2026 backend wymaga JWT na kazdym
      // endpoincie, wiec do NASZEGO backendu token doklejamy takze tutaj.
      // Inne hosty (RestApi PHP, drukarka fiskalna, zewnetrzne API) - bez zmian.
      return next.handle(this.isOfficeApiUrl(req.url) ? this.withToken(req) : req);
    }

    if (req.url.startsWith('./assets') || req.url.startsWith('/assets') || req.url.startsWith('assets/')) {
      return next.handle(req);
    }

    let baseUrl = this.config.apiBaseUrl;
    let url = req.url;

    if (url.startsWith('/eldorado-api')) {
      baseUrl = this.config.eldoradoApiBaseUrl;
      url = url.slice('/eldorado-api'.length);
    } else if (url.startsWith('/b2b-api')) {
      baseUrl = this.config.b2bApiBaseUrl;
      url = url.slice('/b2b-api'.length);
    }

    const apiReq = req.clone({
      url: `${baseUrl}${url}`,
    });

    // Token nowego logowania (patrz core/auth) - dolaczany tylko do wywolan
    // na nasze wlasne backendy.
    return next.handle(this.withToken(apiReq));
  }

  private withToken(req: HttpRequest<any>): HttpRequest<any> {
    const token = this.auth.getToken();
    if (!token || req.headers.has('Authorization')) {
      return req;
    }
    return req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  }

  /** Absolutny URL backendu office: z configu (prod) albo lokalny :3000. */
  private isOfficeApiUrl(url: string): boolean {
    return [this.config.apiBaseUrl, 'https://apioffice.next77.pl', 'http://localhost:3000']
      .filter((origin) => !!origin)
      .map((origin) => origin.replace(/\/+$/, ''))
      .some((origin) => url === origin || url.startsWith(origin + '/'));
  }
}
